module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Step3"
    }
  }, [_c('div', {
    staticClass: "small-12 columns payment-summary"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Payment summary")]), _vm._v(" "), (_vm.packages.length > 1) ? _c('div', {
    staticClass: "summary-pack"
  }, [(
    this.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null &&
    _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack != null
  ) ? _c('div', {
    staticClass: "pack",
    style: ('background-image:url(' +
      _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack.image +
      ')')
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.packages.length > 1) ? _c('div', {
    staticClass: "summary-pack",
    class: _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null &&
      _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy != null ?
      'has-toy' :
      ''
  }, [_c('div', {
    staticClass: "toy",
    style: (_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null &&
      _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy != null ?
      'background-image:url(' +
      _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy.image +
      ')' :
      '')
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('p', {
    staticClass: "product"
  }, [_vm._v(_vm._s(_vm.donation.productname))]), _vm._v(" "), _c('p', {
    staticClass: "amount"
  }, [_vm._v("$" + _vm._s(_vm.donation.amount))]), _vm._v(" "), _c('p', {
    staticClass: "frequency"
  }, [(_vm.donation.type === 'Regular') ? [_vm._v("Monthly")] : (_vm.donation.type === 'Single') ? [_vm._v("One-off")] : (_vm.donation.type === 'Annual') ? [_vm._v("Annually")] : _vm._e()], 2)])]), _vm._v(" "), _c('h2', [_vm._v("Enter payment details")]), _vm._v(" "), (_vm.useNewCheckout) ? _c('div', [_vm._m(0, false, false), _vm._v(" "), _c(_vm.paymentform, {
    ref: "checkout",
    tag: "component",
    on: {
      "success": _vm.processSuccess,
      "retry": _vm.retryPayment
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.useNewCheckout) ? _c('div', [_c('div', {
    staticClass: "iframe-loader"
  }, [(_vm.donation.url) ? _c('iframe', {
    ref: "frame",
    attrs: {
      "frameborder": "0",
      "scrolling": "no",
      "src": _vm.donation.url
    },
    on: {
      "load": _vm.load
    }
  }) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secure"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3519/dist/assets/img/secure-icon.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("Secure")]), _vm._v(" "), _c('p', [_vm._v("payment")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa6a32bc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=csplt5ikear!./~/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./src/components/product/Step3.vue
// module id = 737
// module chunks = 0